import ViewTemplateRegistry from './TemplateRegistry';
const viewTemplates = new Map();
export default function createRegistry(name = '') {
    let registry = viewTemplates.get(name);
    if (!registry) {
        registry = new ViewTemplateRegistry(name);
        viewTemplates.set(name, registry);
    }
    return registry;
}
//# sourceMappingURL=factory.js.map